import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import getOffsetFromDate from '../get-offset-from-date';
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);
import { DEPRECATED_TIMEZONES, DEFAULT_TIMEZONES } from '../contants';
var setTimezoneOffset = function (utcISODate, timezoneName) {
    try {
        var timezone = DEPRECATED_TIMEZONES[timezoneName] || timezoneName;
        var currentOffset = getOffsetFromDate(utcISODate);
        var utcDate = dayjs
            .utc(utcISODate)
            .utcOffset(currentOffset)
            .format('YYYY-MM-DDTHH:mm:ss') + "Z";
        if (DEFAULT_TIMEZONES.includes(timezone)) {
            return utcDate;
        }
        else {
            var date = dayjs.utc(utcDate);
            return dayjs
                .tz(utcDate, timezone)
                .year(date.year())
                .month(date.month())
                .date(date.date())
                .hour(date.hour())
                .minute(date.minute())
                .second(date.second())
                .format();
        }
    }
    catch (err) {
        return utcISODate;
    }
};
export default setTimezoneOffset;
